export default[
    {
        path: '/saude/trabalhador/lista',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/saude/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro dados saúde de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/saude/trabalhador/editar/:id',
        name: 'editar dados saúde de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]